// extracted by mini-css-extract-plugin
export default {"pageWrap":"Wrapper_pageWrap__j32rA"};